import React from 'react'
import {RowProps, Row} from '@modifi/ui'

const FormRow: React.FC<RowProps> = ({children, ...restProps}) => (
  <Row alignItems="end" {...restProps}>
    {children}
  </Row>
)

export default FormRow
